<template>
  <div>
    <div class="container quote-edit">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <div class=quote-edit-wrapper>
        <div class="d-flex justify-content-between quote-edit-nav">
          <div class="action cancel pointer pt-3"><nuxt-link :to="{ name: 'index', query: { quote: quote.quote, author: quote.author }}"><i class="fas fa-chevron-left"></i> Back</nuxt-link></div>
          <div class="action text-primary pointer">
            <strong><button class="btn btn-primary" @click="finish()">Finish</button></strong>
          </div>
        </div>
        <p class="text-center gqp-header" v-if="!self.isPro">Like Quozio? You'll ❤️ Quozio Pro! <router-link :to="{name: 'get-quozio-pro', query: {ref: 'EDQ'}}">Check it out</router-link>.</p>
        <div class="quote-edit-image-wrapper">
          <i class="fas fa-expand-alt expand-control pointer" v-if="showExpand" @click="toggleExpand()"></i>
          <div class="quote-edit-image-panel text-center small-scroll">
            <span id="quote-edit-image-wrapper">
              <!-- quote image will be injected here -->
            </span>
          </div>
        </div>
        <div class="text-right pr-2" @click="toggleTemplatePicker()">
          <i class="fas fa-chevron-circle-down pointer" v-if="!collapsed"></i>
          <i class="fas fa-chevron-circle-up pointer" v-if="collapsed"></i>
        </div>
        <div class="quote-edit-template-wrapper small-scroll">

          <div class="text-center mb-3" v-if="!userTemplates.data.length && self.isPro">
            <small class="mb-3 text-muted">Millions of backgrounds and 100+ fonts</small>
            <div class="mt-2">
              <button class="btn btn-primary btn-primary btn-pill" @click="createTemplate()">Create Your Own Design</button>
            </div>
            <small class="mb-3 text-muted">Or choose a pre-made design below</small>
          </div>

          <div class="text-center mb-3" v-if="!userTemplates.data.length && !self.isPro">
            <small class="mb-3 text-muted">Millions of backgrounds and 100+ fonts</small>
            <div class="mt-2">
              <router-link class="btn btn-primary btn-primary btn-pill" :to="{ name: 'get-quozio-pro', query: { ref: 'CYOD' } }">Create Your Own Design</router-link>
            </div>
            <small class="mb-3 text-muted">Or choose a pre-made design below</small>
          </div>

          <div class="d-flex flex-wrap justify-content-center" v-if="userTemplates.data.length">
            <div class="templates-banner d-flex justify-content-between">
              <div style="display: flex; align-content: center; flex-wrap: wrap;">Your Designs</div>
              <div v-if="self.isPro"><button class="btn btn-primary btn-primary btn-pill btn-sm" @click="createTemplate()"><i class="fas fa-plus"></i>&nbsp;&nbsp;Create</button></div>
              <div v-if="!self.isPro"><router-link class="btn btn-primary btn-primary btn-pill btn-sm" :to="{ name: 'get-quozio-pro', query: { ref: 'CYOD' } }"><i class="fas fa-plus"></i>&nbsp;&nbsp;Create</router-link></div>
            </div>
            <template v-for="(template, index) in userTemplates.data">
              <div v-bind:key="template.templateId" @click="renderImage(template)">
                <img class="template-image-preview pointer" :src="template.previewUrl" />
              </div>
            </template>
          </div>

          <div v-if="userTemplates.data.length">
            <div class="text-center mt-2 mb-4" v-if="userTemplates.pageNext">
              <span class="btn btn-primary btn-primary btn-pill btn-sm" style="margin-right: 5px;" @click="loadMoreUserTemplates()">Load More</span>
            </div>

            <div class="mt-1 mb-3" v-if="!userTemplates.pageNext">
              <hr style="margin-right: 6px; margin-left: 6px;" />
            </div>
          </div>

          <div class="d-flex flex-wrap justify-content-center">
            <template v-for="(template, index) in templates.data">
              <div v-bind:key="template.templateId" @click="renderImage(template)" style="position: relative;">
                <img class="template-image-preview pointer" :src="template.previewUrl" />
                <img class="is-pro-icon" v-if="template.isPro" title="Quozio Pro Design" src="/images/pro.png">
              </div>
            </template>
          </div>

        </div>
      </div>
    </div>

    <b-modal id="modal-get-quozio-pro-templates" title="Get Quozio Pro" hide-footer>
      <p class="text-center"><i class="fas fa-images fa-8x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">Want access to hundreds of additional designs?</h5>
      </p>
      <p class="my-4 text-center">
        Get Quozio Pro and access hundreds of additional designs, add custom watermarks, download full size images and more!
      </p>
      <p class="my-4 text-center">
        <router-link class="btn btn-success btn-lg" :to="{ name: 'get-quozio-pro', query: { ref: 'UPT' } }">Learn More</router-link>
      </p>
    </b-modal>

  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  let isScrolling;
  const templateLimit = 50; // You need enough items that a scrollbar will be generated for the div so that new items will trigger when they scroll to the bottom.

  const setTemplatePickerHeight = () => {
    // Set the quote image height, based on the size of the other items on the page.
    let headerOffset = 48;
    let quoteEditImageEl = document.getElementsByClassName("quote-edit-image-panel");
    let templateWrapperEl = document.getElementsByClassName("quote-edit-template-wrapper");
    if (quoteEditImageEl && quoteEditImageEl[0] && templateWrapperEl && templateWrapperEl[0]) {
      let quoteImageLocation = quoteEditImageEl[0].getBoundingClientRect().top + window.pageYOffset;
      let quotePickerHeight = window.innerHeight - quoteImageLocation - templateWrapperEl[0].offsetHeight - headerOffset;
      document.getElementsByClassName("quote-edit-image-panel")[0].style.height = quotePickerHeight + "px";
    }
  }

  const toggleMinMaxView = (vm) => {

    if (vm.expanded || vm.collapsed) {
      // If the image is expanded or templates are collapsed, we will shrink and uncollapse.
      vm.toggleExpand(false);
      vm.toggleTemplatePicker(false);
    } else {
      // Otherwise, we wil expand and collapse
      vm.toggleExpand(true);
      vm.toggleTemplatePicker(true);
    }

  }

  const loadImage = (vm, url) => {

    var img = new Image();
    img.src = url;
    img.id = "quote-edit-image";
    img.addEventListener("dblclick", () => toggleMinMaxView(vm));

    // Add expanded if we're currently expanded.
    if (vm.expanded) {
      img.classList.add("expanded");
    }

    img.onload = function () {
      // Remove the existing image, add the new image, show or hide the expand button
      const parent = document.getElementById("quote-edit-image-wrapper");
      while (parent.firstChild) {
        parent.firstChild.remove();
      }
      parent.appendChild(img);
      setShowExpanded(vm, img);
    };
  }

  const setShowExpanded = (vm, img) => {
    // Hides or shows the expand button, depending on the image overflowing the div.
    img = img || document.getElementById("quote-edit-image");
    let quoteEditImageWrapperEl = document.getElementsByClassName("quote-edit-image-wrapper");
    let quoteImageEl = document.getElementById("quote-edit-image");
    if (quoteEditImageWrapperEl && quoteEditImageWrapperEl[0] && quoteImageEl) {
      if (quoteEditImageWrapperEl[0].scrollHeight <= img.height) {
        vm.showExpand = true;
      } else {
        vm.showExpand = false;
      }
    }
  }

  export default {
    data() {
      return {
        quote: { quote: "" },
        quoteImage: {},
        templates: { data: [] },
        userTemplates: { data: [] },
        key: null,
        loadingTemplates: false,
        collapsed: false,
        showExpand: false,
        expanded: true,
        templateId: null,
        nextProUrl: null,
        nextStandardUrl: null,
        error: null
      };
    },
    head() {
      return {
        title: "Edit your Quote - Quozio"
      }
    },
    async asyncData({ store, app, params, error }) {

      var self = await store.dispatch("self/get", app.$cookies);
      let templateId = "1013"; // TO_DO get a random template from the library instead of hard-coding it.

      let response = await app.$dataService.get(`/quotes/${params.quoteId}`);
      if (response.error) {
        return error({ statusCode: response.error.status, message: response.error.message, reference: response.error.reference });
      }
      let quote = response.data;

      let imageUrlsResponse = await app.$dataService.get(`/quotes/${params.quoteId}/imageUrls`, { templateId: templateId });
      if (imageUrlsResponse.error) {
        return error({ statusCode: imageUrlsResponse.error.status, message: imageUrlsResponse.error.message, reference: imageUrlsResponse.error.reference });
      }

      quote.imageUrls = imageUrlsResponse.data;

      let userTemplates = { data: [] };

      if (self?.userId) {
        let userTemplatesResponse = await app.$dataService.get("/templates?userId=me&limit=6&desc=true");
        if (userTemplatesResponse.error) {
          return error({ statusCode: response.error.status, message: response.error.message, reference: response.error.reference });
        }
        userTemplates = userTemplatesResponse.data;
      }

      return { quote: response.data, templateId: templateId, userTemplates: userTemplates, key: response.data.imageUrls.key };
    },

    async mounted() {
      loadImage(this, this.quote.imageUrls.large);
      setTemplatePickerHeight();
      await this.getTemplates("/templates", "/templates");
      const scrollBox = document.querySelector(".quote-edit-template-wrapper");
      scrollBox.addEventListener("scroll", this.checkLoadTemplates, false);
    },
    methods: {
      async renderImage(template) {
        this.error = null;

        if (template.isPro && !this.self.isPro) {
          this.$bvModal.show("modal-get-quozio-pro-templates");
          this.$ga.event("GetQuozioPro", "Get Quozio Pro - Pro Template Modal", template.templateId);
          return;
        }

        this.templateId = template.templateId;
        let response = await this.$dataService.get(`/quotes/${this.$route.params.quoteId}/imageUrls`, { templateId: this.templateId });
        if (response.error) {
          this.error = response.error;
          return;
        }
        this.quoteImage = response.data;
        this.key = this.quoteImage.key;

        loadImage(this, this.quoteImage.large);
        this.$ga.event("Template", "Template Examined", template.templateId);
      },
      async finish() {
        this.$router.push({ name: 'quote-quoteId-templateId-quoteSlug', params: { quoteId: this.quote.quoteId, templateId: `${this.templateId}-${this.key}`, quoteSlug: this.quote.slug } });
        this.$ga.event("Quote", "Quote Created - Finish", this.quote.quoteId);
        this.$ga.event("Template", "Template Selected", this.templateId);
      },
      toggleTemplatePicker(status) {
        status = status === undefined ? !this.collapsed : status; // If status is undefined, it will reverse the current setting.
        if (status) {
          document.getElementsByClassName("quote-edit-template-wrapper")[0].classList.add("collapsed");
        } else {
          document.getElementsByClassName("quote-edit-template-wrapper")[0].classList.remove("collapsed");
        }
        this.collapsed = status;
        setTemplatePickerHeight(status);
        setShowExpanded(this);
      },
      toggleExpand(status) {
        status = status === undefined ? !this.expanded : status; // If status is undefined, it will reverse the current setting.
        var quoteImageEl = document.getElementById("quote-edit-image");
        if (quoteImageEl) {
          status ? quoteImageEl.classList.add("expanded") : quoteImageEl.classList.remove("expanded");
        }
        this.expanded = status;
      },
      async getMoreTemplates() {
        if (this.templates && (this.nextProUrl || this.nextStandardUrl)) {
          this.loadingTemplates = true;
          await this.getTemplates(this.nextProUrl, this.nextStandardUrl);
          this.loadingTemplates = false;
        }
      },
      async loadMoreUserTemplates() {
        if (this.userTemplates && this.userTemplates.pageNext) {
          let params = { limit: 18, desc: true, userId: "me", after: this.getQueryStringValue(this.userTemplates.pageNext, "after") };
          let response = await this.$dataService.get("/templates", params);
          if (response.error) {
            this.error = response.error;
            return;
          }
          this.userTemplates.data = this.userTemplates.data.concat(response.data.data);
          this.userTemplates.pageNext = response.data.pageNext;
        }
      },
      checkLoadTemplates() {
        window.clearTimeout(isScrolling);
        let vm = this;
        isScrolling = setTimeout(function () {
          var el = document.querySelector(".quote-edit-template-wrapper");
          if (!vm.loadingTemplates && el && ((el.scrollHeight - el.scrollTop - el.clientHeight) < 350)) {
            vm.getMoreTemplates();
          }
        }, 75);
      },
      async getTemplates(nextProUrl, nextStandardUrl) {

        let percentageStandard = 0.55;
        let limitStandard = Math.round(templateLimit * percentageStandard);
        let limitPro = templateLimit - limitStandard;
        let templatesPro = { data: [] };
        let templatesStandard = { data: [] };

        if (nextProUrl) {
          let paramsPro = { limit: limitPro, desc: true, isPro: true, after: this.getQueryStringValue(nextProUrl, "after") };
          let responsePro = await this.$dataService.get(nextProUrl, paramsPro);
          if (responsePro.error) {
            this.error = responsePro.error;
            return;
          }
          templatesPro = responsePro.data;
          this.nextProUrl = templatesPro.pageNext;
        }

        if (nextStandardUrl) {
          let paramsStandard = { limit: limitStandard, desc: true, isPro: false, after: this.getQueryStringValue(nextStandardUrl, "after") };
          let responseStandard = await this.$dataService.get(nextStandardUrl, paramsStandard);
          if (responseStandard.error) {
            this.error = responseStandard.error;
            return;
          }
          templatesStandard = responseStandard.data;
          this.nextStandardUrl = templatesStandard.pageNext;
        }

        let combinedTemplates = templatesStandard.data.concat(templatesPro.data);
        combinedTemplates = this.shuffle(combinedTemplates, 1234567);
        this.templates.data = this.templates.data.concat(combinedTemplates);
      },
      createTemplate() {
        this.$router.push({ name: "design-new", query: { quoteId: this.quote.quoteId } });
        this.$ga.event("UIUX", "Create Your Own Design", "From Quote");
      },
      getQueryStringValue(url, param) {
        if (url) {
          const urlParams = new URLSearchParams(url.split('?')[1]);
          return urlParams.get(param);
        }
        return null;
      },
      shuffle(array, seed) {
        const random = (x) => {
          const a = 1664525;
          const c = 1013904223;
          const m = Math.pow(2, 32);
          x = (a * x + c) % m;
          return x / m;
        };

        let currentIndex = array.length;
        let temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex !== 0) {

          // Pick a remaining element...
          randomIndex = Math.floor(random(seed) * currentIndex);
          currentIndex--;

          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
      },
    },
    beforeDestroy: function () {
      window.removeEventListener("scroll", this.checkLoadTemplates, false);
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
  };

</script>
